/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

import 'lazysizes';
import { gsap, Power3, ScrollTrigger } from 'gsap/all';
import { CustomEase } from './gsap-bonus/CustomEase';
import { debounce } from 'lodash';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Rellax from 'rellax';
import Router from './router';

import Vue from 'vue';
import zenScroll from 'zenscroll';

// gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);

require('./components/page-header-component');
require('./components/intro-animation-component');
require('./components/scroll-navigation-component');
require('./components/slider-component');
require('./components/panel-slider');
require('./components/ticker-component');
require('./components/ticker-team-component');
require('./components/language-selector');
require('./components/testimonial-component');
require('./components/scroll-slider-component');
require('./components/related-cases-component');
require('./components/news-sidebar');
require('./components/latest-section');
require('./components/news-slider');
require('./components/enquiries-form-component');
require('./components/work-slider-component');
require('./components/newsletter-component');
require('./components/navigation-component');
require('./components/news-slider-work');
require('./components/back-button');
require('./components/video-component');
require('./components/case-slider');
require('./components/work-grid-component');


const App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            router: {
                currentSection: null,
                instance: null,
                prefetch: true
            },
            // router: null,
            isMobile: false,
            isTablet: false,
            // scrollbar: null,
            inTransition: false,
            lightHeader: false,
            showNavigation: false,
            showTestimonial: false,
            showIntroAnimation: true,
            showFooter: '1',
            section: 'null',
        };
    },

    watch: {
        isMobile: function (value) {
            EventBus.$emit('is-mobile-changed');
        },
        isTablet: function (value) {
            EventBus.$emit('is-tablet-changed');
        },
        showNavigation: function (visibile) {
            EventBus.$emit('navigation-state-changed', visibile);
        }
    },

    mounted() {
        this.lightHeader = this.$el.dataset.initialLightHeader;
        this.showFooter = this.$el.dataset.initialShowFooter;

        this.router = new Router({
            instance: this,
            prefetch: true,
            section: this.$el.dataset.initialSection,
            ignoreComponents: [
                'language-selector',
                'testimonial-component',
                'navigation-component'
            ]
        });

        this.section = document.getElementById('page-container').dataset.pageSection;

        if (this.router.currentSection === 'page-home') {
            EventBus.$emit('play-intro-animation');
        } else {
            this.showIntroAnimation = false;
        }

        // Initial detect of mobile/tablet breakpoints
        this.detectMobile();
        EventBus.$on('window-resize', () => {
            this.detectMobile();
        });

        window.addEventListener('resize', this.onWindowResize);

        window.addEventListener('wheel', this.stopScrolling);

        window.requestAnimationFrame(() => {
            const parallax = [...document.querySelectorAll('.rellax')];
            if (parallax.length > 0) {
                var rellax = new Rellax('.rellax');
            }
        })

        this.initRevealTriggers();

        EventBus.$on('page-transition-enter-complete', () => {
            Vue.nextTick(() => {
                this.initRevealTriggers();
            });
        });
    },

    methods: {
        stopScrolling() {
            if (zenScroll.moving()) {
                zenScroll.stop();
            }
        },

        openTestimonials(slide) {
            const onComplete = (slide) => {
                this.inTransition = false;
                EventBus.$emit('initTestimonials', slide);
            };

            document.body.classList.add('testimonial-open');
            disableBodyScroll(document.querySelector('#overlay-testimonials'));

            //open for mobile
            if (window.matchMedia("(max-width: 1023px)").matches) {
                gsap.to('.hamburger__line3', { duration: 0.3, width: '25px' });
                gsap.to("#header", { duration: 2, height: '107px', ease: 'power3.out' });
                gsap.to("#overlay-testimonials", { duration: 2, y: 0, ease: 'power4.out' });
                gsap.to(".header__logo-link", { duration: 2, height: '54px', ease: Power3.out });
                gsap.to('.hamburger__line1', { delay: 1.1, duration: 0.3, scaleX: '0' });
                gsap.to('.hamburger__line3', { delay: 1.1, duration: 0.3, scaleX: '0' });
                gsap.to('.hamburger__line2', { delay: 1.6, duration: 0.3, rotate: '-45deg' });
                gsap.to('.hamburger__line4', { delay: 1.6, duration: 0.3, rotate: '45deg', onComplete: onComplete(slide) });

                return;
            }

            //open for desktop
            gsap.to('.hamburger__line3', { duration: 0.3, width: '25px' });
            gsap.to("#header", { duration: 2, width: '145px', ease: 'power3.out' });
            gsap.to("#overlay-testimonials", { duration: 2, x: 0, ease: 'power4.out' });
            gsap.to(".header__logo-link", { duration: 2, width: '77px', ease: 'power3.out' });
            gsap.to('.hamburger__line1', { delay: 1.1, duration: 0.3, scaleX: '0' });
            gsap.to('.hamburger__line3', { delay: 1.1, duration: 0.3, scaleX: '0' });
            gsap.to('.hamburger__line2', { delay: 1.6, duration: 0.3, rotate: '-45deg' });
            gsap.to('.hamburger__line4', { delay: 1.6, duration: 0.3, rotate: '45deg', onComplete: onComplete(slide) });
        },

        initRevealTriggers() {
            const elements = [
                ...document.querySelectorAll('.a-fade-up'),
                ...document.querySelectorAll('.a-fade-in'),
                ...document.querySelectorAll('[data-reveal]'),
                ...document.querySelectorAll('[data-image-reveal]'),
                ...document.querySelectorAll('[data-video-reveal]')
            ];

            elements.forEach((element) => {
                const { revealDelay, revealManually, revealPosition } = element.dataset;
                if (revealManually === '') {
                    return;
                }

                if (revealPosition) {
                    console.log(revealPosition);
                }

                const startPercentage = revealPosition || '90%';

                ScrollTrigger.create({
                    trigger: element,
                    start: `top ${startPercentage}`,
                    onEnter: () => {
                        if (!revealDelay) {
                            element.classList.add('--revealed');
                            return;
                        }

                        gsap.delayedCall(revealDelay, () => {
                            element.classList.add('--revealed');
                        });
                    }
                });
            });
        },

        /**
         * Raised when the client window is resizing.
         *
         * @return {Void}
         */
        onWindowResize: debounce(() => {
            EventBus.$emit('window-resize');
        }, 150),

        detectMobile() {
            this.isMobile = window.innerWidth <= 768;
            this.isTablet = window.innerWidth <= 1024;
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    }
});
